import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getTenantName } from '@/utils';
/**
 * Shared base query for all client-key authenticated API slices.
 *
 * These slices authenticate via `Authorization: client-key <key>` (set
 * per-endpoint) rather than the Bearer-token auth used by `ccApi`.
 * This factory provides the common configuration:
 * - Empty `baseUrl` (each endpoint supplies the full URL from config)
 * - `X-Groupby-Customer-Id` header derived from the current tenant
 * - Default `Content-Type` and `Accept` JSON headers (skipped when
 *   already set, e.g. for FormData uploads)
 */
export const clientKeyBaseQuery = fetchBaseQuery({
    baseUrl: '',
    prepareHeaders: (headers) => {
        const customerId = getTenantName();
        if (customerId) {
            headers.set('X-Groupby-Customer-Id', customerId);
        }
        // Accept JSON by default; Content-Type is set automatically by
        // fetchBaseQuery when it serialises a JSON body, and must NOT be
        // forced here — doing so breaks FormData uploads (multipart boundary).
        if (!headers.has('Accept')) {
            headers.set('Accept', 'application/json');
        }
        return headers;
    },
});
